import { QueryClient } from '@tanstack/react-query';

export const CACHE_MAX_AGE = 7 * 24 * 60 * 60 * 1000;

export function createFinanceQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      mutations: { networkMode: 'online', retry: 0 },
      queries: {
        gcTime: CACHE_MAX_AGE,
        networkMode: 'offlineFirst',
        refetchOnWindowFocus: true,
        retry: 1,
        staleTime: 30_000,
      },
    },
  });
}
